export const initialState = {
  cartItems: [],
};
